module.exports = __webpack_public_path__ + "static/media/997663.527b04a0.jpg";